import {useQuery} from "@tanstack/react-query";
import {fetchApprovedLocations} from "flux/clients/locations";
import mapValues from "utils/arraysHelper";
import isAfter from "date-fns/isAfter";
import parseISO from "date-fns/parseISO";

const NOW = new Date();

const useApprovedLocations = () => {
  return useQuery(['approvedLocations'], fetchApprovedLocations,
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      placeholderData: [],
      select: (locations) => {
        return locations
          .map((location) => mapValues(location, (value) => !!value && value.toLowerCase ? value.toLowerCase() : value))
          .map(f => ({
            ...f,
            isComingSoon: f.launch_date ? isAfter(parseISO(f.launch_date), NOW) : false,
          })) ?? []
      }
    },
  );
};

export default useApprovedLocations;